export default "__VITE_ASSET__BZS3OU$S__"